<template>
	<div>
		<Header :title="strings.room.title">{{ strings.room.header }}</Header>

		<QrFab />
	</div>
</template>

<script>
import strings from "@/utils/strings";

import Header from "../shared/Header";
import QrFab from "../shared/QrFab";

export default {
	components: { Header, QrFab },

	data: () => ({
		strings,
	}),
};
</script>
